<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Token Management",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Token Management",
            items: [
               {
                  text: "Token Management",
                  active: true,
               },                   
            ],

            listing_length: 100,
            keyword: '',
            payments: [],           
            today_count:0,
            pagination: {},            
            start:false,
            end:true,
            start1:false,
            end1:true,
            token: "",
            tokens: {},
            errors: {},
            noShowTokens: [],
            doctor:{
               room: "",
            } , 
            doctorTokens : {},   
            doctor_current_tokens  : {},   
            active_page_url: null,
            from: "",
            to: "",
            total: "",
            links: "",
            modal_title: "Add Room Number",
            button_title: "Save",
            room:false,
            selectedDoctorId: null,
            selectedDoctorIds: [],
            selectedBookingId: "",
            doctor_id:"",
            pollingInterval: null,  // Store the polling interval

         };
      },
      mounted() {
         if (this.$route.name === 'doctors.tokens') {
            this.longPollRefreshStatus();  // Start polling if on the correct page
            this.pollingInterval = setInterval(this.longPollRefreshStatus, 8000); 
         }
      },
      beforeDestroy() {
         // Clean up the polling interval when the component is destroyed
         if (this.pollingInterval) {
            clearInterval(this.pollingInterval);
         }
      },
      created(){
         this.fetchTokens();
      },

      methods: {
         longPollRefreshStatus() {
         this.getToken();
         let url = "clinic/todaysCount";
         this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               var responseData = res.data;
               console.log("Doctor Tokens:", this.doctorTokens); 
               if (!this.tokens.length) {
                  console.warn("⚠️ Token list is empty. Fetching new tokens...");
                  this.fetchTokens();
                  return;
               }
               const flattenedTokens = this.tokens.flat();
               console.log("Flattened Tokens:", flattenedTokens);
               this.doctor_current_tokens = responseData.data.doctor_tokens;

               for (const [doctorId, currentToken] of Object.entries(this.doctor_current_tokens)) {
                  console.log(`Checking doctorId: ${doctorId} with Current Token: ${currentToken}`);

                  const firstToken = flattenedTokens.find(token => token.doctor_id == String(doctorId));
                  
                  if (firstToken) {
                     console.log(`First Token Found for Doctor ${doctorId}:`, firstToken);
                     if(firstToken.clinic_current_token != currentToken){
                        this.fetchTokens();
                     }else{
                         console.log('Mismatch ');
                     }
                  } else {
                     console.warn(`⚠️ No token found for Doctor ${doctorId} in this.tokens.`);
                  }
               }
               // console.log(responseData);
               if (this.today_count !== responseData.data.bookings_count) {
                  this.today_count = responseData.data.bookings_count;
                  console.log( this.today_count);
                  this.fetchTokens();  // Refresh tokens if the count changes
               }
            })
            .catch((error) => {
               if (error.response) {
                  if (error.response.data.message) {
                     this.$swal("", error.response.data.message, "error");
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
            })
            .finally(() => (this.loading = false));
      },


         fetchTokens(page_url = null){

         this.getToken();
         let url = "clinic/doctor/tokens?limit=" + this.listing_length;

         page_url = page_url || url;

         if(localStorage.back_url) {
            page_url = localStorage.back_url;  
            localStorage.removeItem('back_url');
         }    

         this.active_page_url = page_url;
         this.loading = true;

         this.$axios
            .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               var responseData = res.data.data;
               this.tokens = responseData.tokens.data;
               this.tokenArrays = Object.values(this.tokens);
               if (this.tokenArrays.length > 0) {
                     this.tokenArrays.forEach(token_array => {
                        token_array.forEach(token => {
                              if (token.start_session_status) {
                                 this.selectedDoctorIds.push(token.doctor_id);
                              }
                              console.log("token:",token);

                        });
                        console.log("token_array:",token_array[0]);
                        let firstToken = token_array[0];
                        this.doctorTokens[firstToken.doctor_id] = firstToken.clinic_current_token;
                     });
                  }
               console.log("Doctor ids:",this.selectedDoctorIds);
               console.log("Doctor Tokens:", this.doctorTokens); 
               this.from = responseData.tokens.from;
               this.to = responseData.tokens.to;
               this.total = responseData.tokens.total;
               this.links = responseData.tokens.links;

               console.log(this.tokens);
         })
         .catch((error) => {
               if (error.response) {
                  if (error.response.data.message) {
                     if(typeof error.response.data.message === 'object') {
                        console.log(error.response.status);
                     } else {
                        this.$swal("", error.response.data.message, "error");
                     }                        
                     
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
         })
         .finally(() => (this.loading = false));


         },

         // markAsNoShowCall(booking_id, end, next_booking_id){
         //       if(end == 2) {  
         //          this.markAsNoShow(booking_id, next_booking_id);    
         //       }else{
         //          this.$bvModal.msgBoxOk('No more bookings available for this session.', {
         //          title: 'No More Bookings',
         //          size: 'sm',
         //          buttonSize: 'sm',
         //          okVariant: 'danger',
         //          okTitle: 'OK',
         //          footerClass: 'p-2',
         //          hideHeaderClose: true,
         //          centered: true
         //    })
         //    .then(value => {
         //          // Handle the response from the dialog if necessary
         //          console.log('Dialog closed with response:', value);
         //          this.markAsNoShow(booking_id,'');
         //    })
         //    .catch(err => {
         //          console.log('Error:', err);
         //    });
         // }
         
         // },
     
         markAsNoShowCall(booking_id, end, next_booking_id,){
               console.log(end);
               let content = next_booking_id 
                     ? "Are you sure you want to mark this current consultation as a no-show?" 
                     : "No more bookings available for this session. Are you sure you want to mark this current consultation as a no-show?";
               let next_booking_id1 = next_booking_id 
                     ? next_booking_id 
                     : "";   
               let title = next_booking_id 
                     ? "Confirm" 
                     : "No more bookings";   
               this.delete = false;
                  this.$bvModal.msgBoxConfirm(content, {
                        title: title,
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'danger',
                        okTitle: 'Yes',
                        cancelTitle: 'No',
                        footerClass: 'p-2',
                        hideHeaderClose: false,
                        centered: true
                  })
                  .then(value => {
                     this.delete = value
                     if(this.delete){
                        let url = "clinic/doctor/mark_as_noshow?booking_id=" + booking_id + '&next_booking_id='+ next_booking_id1 ;
            this.getToken();
            this.loading = true;
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((response) => {
                     if (response.data.status) {
                        this.$swal("", response.data.message, "success");
                     } else {
                        this.$swal("", response.data.message, "error");
                     }
                     this.fetchTokens();
               })
               .catch((error) => {
                     if (error.response) {
                        if (error.response.data.message) {
                           if (typeof error.response.data.message === 'object') {
                                 console.log(error.response.status);
                                 const errorMessage = error.response.data.message.join(', '); // Convert array to comma-separated string
                                 this.$swal("", errorMessage, "error");
                           } else {
                                 this.$swal("", error.response.data.message, "error");
                           }
                        } else {
                           this.$swal("", "Something went wrong", "error");
                        }
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
               })
               .finally(() => (this.loading = false));
                     }
                  })
                  .catch(err => {
                     console.log(err);
                  })
         
         },
         markAsNoShow(booking_id,next_booking_id) {
          

            let url = "clinic/doctor/mark_as_noshow?booking_id=" + booking_id + '&next_booking_id='+ next_booking_id ;
            this.getToken();
            this.loading = true;
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((response) => {
                     if (response.data.status) {
                        this.$swal("", response.data.message, "success");
                     } else {
                        this.$swal("", response.data.message, "error");
                     }
                     this.fetchTokens();
               })
               .catch((error) => {
                     if (error.response) {
                        if (error.response.data.message) {
                           if (typeof error.response.data.message === 'object') {
                                 console.log(error.response.status);
                                 const errorMessage = error.response.data.message.join(', '); // Convert array to comma-separated string
                                 this.$swal("", errorMessage, "error");
                           } else {
                                 this.$swal("", error.response.data.message, "error");
                           }
                        } else {
                           this.$swal("", "Something went wrong", "error");
                        }
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
               })
               .finally(() => (this.loading = false));
         },

         
         callNextToken(booking_id, next_booking_id){
                 
         this.getToken();

         const config = {
               headers: {
                  "Content-type": "application/json",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
         };

         let url = "clinic/doctor/call_next_token";
         let formData = new FormData();
         formData.append("booking_id", booking_id);
         formData.append("next_booking_id", next_booking_id);
         this.loading = true;

         this.$axios
               .post(url, formData, config)
               .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.fetchTokens();
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                           if (typeof error.response.data.message === 'object') {
                              console.log(error.response.status);
                              const errorMessage = error.response.data.message.join(', '); // Convert array to a comma-separated string
                              this.$swal("", errorMessage, "error");
                           } else {
                              this.$swal("", error.response.data.message, "error");
                           }
                     } else {
                           this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));

        },

         // callNext(booking_id, doctor_id, next_booking_id,){
         //       console.log(booking_id);    
         //       console.log(doctor_id); 
         //       if(next_booking_id) {  
         //          this.callNextToken(booking_id, next_booking_id);    
         //       }else{
         //          this.$bvModal.msgBoxOk('No more bookings available for this session.', {
         //          title: 'No More Bookings',
         //          size: 'sm',
         //          buttonSize: 'sm',
         //          okVariant: 'danger',
         //          okTitle: 'OK',
         //          footerClass: 'p-2',
         //          hideHeaderClose: true,
         //          centered: true
         //    })
         //    .then(value => {
         //          // Handle the response from the dialog if necessary
         //          console.log('Dialog closed with response:', value);
         //          this.callNextToken(booking_id,'');
         //    })
         //    .catch(err => {
         //          console.log('Error:', err);
         //    });
         // }
         
         // },

         callNext(booking_id, doctor_id, next_booking_id,){
               console.log(booking_id);    
               console.log(doctor_id); 
               let content = next_booking_id 
                     ? "Are you sure you want to mark this current consultation as complete?" 
                     : "No more bookings available for this session. Are you sure you want to mark this current consultation as complete?";
               let next_booking_id1 = next_booking_id 
                     ? next_booking_id 
                     : "";  
               let title = next_booking_id 
                     ? "Confirm" 
                     : "No more bookings";    
               this.delete = false;
                  this.$bvModal.msgBoxConfirm(content, {
                        title: title,
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'danger',
                        okTitle: 'Yes',
                        cancelTitle: 'No',
                        footerClass: 'p-2',
                        hideHeaderClose: false,
                        centered: true
                  })
                  .then(value => {
                     this.delete = value
                     if(this.delete){
                        this.getToken();

         const config = {
               headers: {
                  "Content-type": "application/json",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
         };

         let url = "clinic/doctor/call_next_token";
         let formData = new FormData();
         formData.append("booking_id", booking_id);
         formData.append("next_booking_id", next_booking_id1);
         this.loading = true;

         this.$axios
               .post(url, formData, config)
               .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.fetchTokens();
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                           if (typeof error.response.data.message === 'object') {
                              console.log(error.response.status);
                              const errorMessage = error.response.data.message.join(', '); // Convert array to a comma-separated string
                              this.$swal("", errorMessage, "error");
                           } else {
                              this.$swal("", error.response.data.message, "error");
                           }
                     } else {
                           this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
                     }
                  })
                  .catch(err => {
                     console.log(err);
                  })
         
         },
        
         fetchNoShowTokens(doctor_id) {
            let url = "clinic/doctor/noshow_tokens?doctor_id=" + doctor_id;
            this.getToken();
            this.loading = true;
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                     var responseData = res.data.data;
                     this.noShowTokens = responseData.noshow_tokens;
                     console.log(this.noShowTokens);
               })
               .catch((error) => {
                     if (error.response) {
                        if (error.response.data.message) {
                           if (typeof error.response.data.message === 'object') {
                                 console.log(error.response.status);
                           } else {
                                 this.$swal("", error.response.data.message, "error");
                           }
                        } else {
                           this.$swal("", "Something went wrong", "error");
                        }
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
               })
               .finally(() => (this.loading = false));
         },

        tokenRecall(booking_id,status){

         this.getToken();

         const config = {
               headers: {
                  "Content-type": "application/json",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
         };

         let url = "clinic/doctor/recall";
         let formData = new FormData();
         formData.append("booking_id", booking_id);
         formData.append("recall", status);
         this.loading = true;
         this.$axios
               .post(url, formData, config)
               .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.hideModal('noshow-modal')
                  this.fetchTokens();
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                           if (typeof error.response.data.message === 'object') {
                              console.log(error.response.status);
                              const errorMessage = error.response.data.message.join(', '); // Convert array to a comma-separated string
                              this.$swal("", errorMessage, "error");
                           } else {
                              this.$swal("", error.response.data.message, "error");
                           }
                     } else {
                           this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));




        },


         addRoom(){

            if (!this.doctor.room) {
               // Room already exists, skip add room API and directly call startSessionApi
               this.hideModal('addroom-modal')
               this.selectedDoctorIds.push(this.doctor_id);
               this.start = true;
               this.end = false;
               this.startSessionApi();
               return;
            }
            this.getToken();

            const config = {
                  headers: {
                     "Content-type": "application/json",
                     "Accept": "application/json",
                     "Authorization": "Bearer " + this.token,
                  },
            };

            let url = "clinic/doctor/room_add";
            let formData = new FormData();
            formData.append("doctor_id", this.doctor_id);
            formData.append("room", this.doctor.room);
            this.loading = true;

            this.$axios
                  .post(url, formData, config)
                  .then((response) => {
                     if (response.data.status) {
                        this.$swal("", response.data.message, "success");
                     } else {
                        this.$swal("", response.data.message, "error");
                     }
                     this.hideModal('addroom-modal')
                     this.selectedDoctorIds.push(this.doctor_id);
                     this.start = true;
                     this.end = false;
                     this.room = true;
                     this.startSessionApi();
                     // this.fetchTokens();
                     // this.clearForm();
                  })
                  .catch((error) => {
                     if (error.response) {
                        if (error.response.data.message) {
                              if (typeof error.response.data.message === 'object') {
                                 console.log(error.response.status);
                                 const errorMessage = error.response.data.message.join(', '); // Convert array to a comma-separated string
                                 this.$swal("", errorMessage, "error");
                              } else {
                                 this.$swal("", error.response.data.message, "error");
                              }
                        } else {
                              this.$swal("", "Something went wrong", "error");
                        }
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  })
                  .finally(() => (this.loading = false));
            
         },
         
         startSessionApi(){

         this.getToken();

         const config = {
               headers: {
                  "Content-type": "application/json",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
         };

         let url = "clinic/doctor/tokens/start_session";
         let formData = new FormData();
         formData.append("booking_id", this.selectedBookingId);
         this.loading = true;

         this.$axios
               .post(url, formData, config)
               .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.fetchTokens();
                  this.clearForm();
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                           if (typeof error.response.data.message === 'object') {
                              console.log(error.response.status);
                              const errorMessage = error.response.data.message.join(', '); // Convert array to a comma-separated string
                              this.$swal("", errorMessage, "error");
                           } else {
                              this.$swal("", error.response.data.message, "error");
                           }
                     } else {
                           this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));

         },

         // endSession(doctor_id){

         // this.getToken();

         // const config = {
         //       headers: {
         //          "Content-type": "application/json",
         //          "Accept": "application/json",
         //          "Authorization": "Bearer " + this.token,
         //       },
         // };

         // let url = "clinic/doctor/tokens/endSession";
         // let formData = new FormData();
         // formData.append("doctor_id", doctor_id);
         // this.loading = true;

         // this.$axios
         //       .post(url, formData, config)
         //       .then((response) => {
         //          if (response.data.status) {
         //             this.$swal("", response.data.message, "success");
         //          } else {
         //             this.$swal("", response.data.message, "error");
         //          }
         //          if (this.selectedDoctorIds.includes(doctor_id)) {
         //             // Remove the doctor_id from the array
         //             this.selectedDoctorIds = this.selectedDoctorIds.filter(id => id !== doctor_id);
         //          }
         //          this.fetchTokens();
         //          this.clearForm();
         //       })
         //       .catch((error) => {
         //          if (error.response) {
         //             if (error.response.data.message) {
         //                   if (typeof error.response.data.message === 'object') {
         //                      console.log(error.response.status);
         //                      const errorMessage = error.response.data.message.join(', '); // Convert array to a comma-separated string
         //                      this.$swal("", errorMessage, "error");
         //                   } else {
         //                      this.$swal("", error.response.data.message, "error");
         //                   }
         //             } else {
         //                   this.$swal("", "Something went wrong", "error");
         //             }
         //          } else {
         //             this.$swal("", "Something went wrong", "error");
         //          }
         //       })
         //       .finally(() => (this.loading = false));

         // },

         endSession(doctor_id){
                  
               this.delete = false;
                  this.$bvModal.msgBoxConfirm("No more bookings are there. Are you sure you want to end the session", {
                        title: 'End Session',
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'danger',
                        okTitle: 'Yes',
                        cancelTitle: 'No',
                        footerClass: 'p-2',
                        hideHeaderClose: false,
                        centered: true
                  })
                  .then(value => {
                     this.delete = value
                     if(this.delete){
                         this.getToken();

               const config = {
                     headers: {
                        "Content-type": "application/json",
                        "Accept": "application/json",
                        "Authorization": "Bearer " + this.token,
                     },
               };

               let url = "clinic/doctor/tokens/endSession";
               let formData = new FormData();
               formData.append("doctor_id", doctor_id);
               this.loading = true;

               this.$axios
               .post(url, formData, config)
               .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  if (this.selectedDoctorIds.includes(doctor_id)) {
                     // Remove the doctor_id from the array
                     this.selectedDoctorIds = this.selectedDoctorIds.filter(id => id !== doctor_id);
                  }
                  this.fetchTokens();
                  this.clearForm();
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                           if (typeof error.response.data.message === 'object') {
                              console.log(error.response.status);
                              const errorMessage = error.response.data.message.join(', '); // Convert array to a comma-separated string
                              this.$swal("", errorMessage, "error");
                           } else {
                              this.$swal("", error.response.data.message, "error");
                           }
                     } else {
                           this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
                     }
                  })
                  .catch(err => {
                     console.log(err);
                  })
         
         },
         getToken() {
         if (localStorage.getItem('medicino_clinic')) {
            var medicino_clinic =  JSON.parse(localStorage.getItem('medicino_clinic'));
            if(medicino_clinic.token) {
               this.token = medicino_clinic.token;
            } else {
               this.$swal("", "Failed to fetch token, please login again", "error");
               this.$router.push({ name: "login" });
            }
            
         } else {
            this.$swal("", "Session expired, please login again", "error");
            this.$router.push({ name: "login" });
         }
         },


         startSession(doctor_id,Booking_id,room){
            // this.selectedDoctorId = doctor_id;
            // this.selectedDoctorIds.push(doctor_id);
            // this.selectedBookingId = Booking_id;
            // this.start = true;
            // this.end = false;
            // this.room = true;
            this.doctor_id = doctor_id;
            this.selectedBookingId = Booking_id; 
            if(room){
               this.doctor.room = room;
            }           
            this.showModal('addroom-modal');
         },
         startSession1(){
          
            this.start1 = true;
            this.end1 = false;
            this.room = true;
            this.showModal('addroom-modal');
         },
        showTokens(doctor_id){
            this.fetchNoShowTokens(doctor_id);
            this.modal_title= "Noshow Tokens",
            this.showModal('noshow-modal');
         },
         showModal(modal) {
            this.$refs[modal].show();
         },

         hideModal(modal) {
            this.$refs[modal].hide();
         },
         clearForm() {        
            this.doctor.room = "";
         },

         calculateAge(dob) {
            const currentDate = new Date();
            const birthDate = new Date(dob);

            let age = currentDate.getFullYear() - birthDate.getFullYear();

            const currentMonth = currentDate.getMonth();
            const birthMonth = birthDate.getMonth();

            if (currentMonth < birthMonth || (currentMonth === birthMonth && currentDate.getDate() < birthDate.getDate())) {
            age--;
            }

            return age;
         },
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  

                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <!-- <div class="col-sm-12 col-md-6">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length" @change="fetchTokens()">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div> -->
                     <!-- <div class="col-sm-12 col-md-6">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword"/>
                           </label>
                        </div>                                      
                        
                     </div> -->
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered">
                        <thead class="table-light">
                           <tr>
                              <th width="20%">Doctor</th>                  
                              <th width="30%">Current Token</th>
                              <th width="25%">Next Token</th>
                              <th width="25%">Options</th>

                           </tr>
                        </thead>
                        <tbody v-if="tokens && Object.keys(tokens).length > 0">                           
                           <tr v-for="(token) in tokens" :key="token.id">
                              <td>
                                 <span v-if="token[0].prefix == 1">Dr.</span><span v-else-if="token[0].prefix == 2">Mr.</span><span v-else-if="token[0].prefix == 3">Ms.</span> {{ token[0].doctor_name }}
                                 <span v-if="token[0].room"> - Room No : {{ token[0].room }}</span>
                              </td>
                              <td>
                                 <span v-if="token[0].booking_id">
                                 <span v-if="token[0].patient_id">{{token[0].patient_name}}</span><span v-else>Guest Patient</span> | <span class="badge bg-primary rounded-pill font-size-18">{{token[0].token}}</span><br>
                                <span v-if="token[0].patient_id">Age: {{ calculateAge(token[0].dob) }} | 
                                 <span v-if="token[0].gender === 1">Male</span>
                                 <span v-if="token[0].gender === 2">Female</span>
                                 <span v-if="token[0].gender === 3">Others</span><br></span>
                                 Consultation Time: {{token[0].consultation_start}} - {{token[0].consultation_end}}<br>
                                 <router-link :to="{ name: 'patients.records', params:{id:token[0].patient_id} }" v-if="token[0].patient_id" >Previous health records</router-link>
                                 <router-link :to="{ name: 'doctors.tokens.symptoms', params:{id:token[0].booking_id} }" class="float-end" v-if="token[0].patient_symptoms != null">Symptoms</router-link><br>

                                    <b-button variant="primary" class="btn-sm mt-2 mr-1" v-if="selectedDoctorIds.includes(token[0].doctor_id) && token[0].current_token_status" @click="markAsNoShowCall(token[0].booking_id,token[1] == null ? 1 : 2,token[1] == null ? null :token[1].booking_id)">Mark as No Show</b-button>
                                    {{ }}
                                    <!-- <b-button variant="primary" class="btn-sm mt-2 mr-1" v-if="selectedDoctorIds.includes(token[0].doctor_id) && token[1]" @click="callNextToken(token[0].booking_id, token[1].booking_id)">Call next Token</b-button> -->
                                    <!-- <b-button variant="primary" class="btn-sm mt-2 mr-1" v-if="selectedDoctorIds.includes(token[0].doctor_id) && token[1]==null||''" @click="endSession(token[0].booking_id,token[0].doctor_id)">End session</b-button> -->
                                    <b-button variant="primary" class="btn-sm mt-2 mr-1" v-if="selectedDoctorIds.includes(token[0].doctor_id) && token[0].current_token_status" @click="callNext(token[0].booking_id,token[0].doctor_id,  token[1] ? token[1].booking_id : null)">Call next Token</b-button>
                                    <b-button variant="primary" class="btn-sm mt-2 mr-1" v-if="selectedDoctorIds.includes(token[0].doctor_id) && !token[0].current_token_status" @click="tokenRecall(token[0].booking_id,2)">Call</b-button>


                                 </span> 
                                    <b-button variant="primary" class="btn-sm mt-2 mr-1" v-if="selectedDoctorIds.includes(token[0].doctor_id) && !(token[0].booking_id) && token[0].start_session_status" @click="endSession(token[0].doctor_id)">End session</b-button>

                              </td>
                              <td v-if="token[1]">
                                 <span v-if="token[1].patient_id">{{ token[1].patient_name }}</span><span v-else>Guest Patient</span> | <span class="badge bg-primary rounded-pill font-size-18">{{ token[1].token }}</span><br>
                                 <span v-if="token[1].patient_id">Age: {{ calculateAge(token[1].dob) }} | 
                                 <span v-if="token[1].gender === 1">Male</span>
                                 <span v-if="token[1].gender === 2">Female</span>
                                 <span v-if="token[1].gender === 3">Others</span><br></span>
                                 Consultation Time: {{ token[1].consultation_start }} - {{ token[1].consultation_end }}<br>
                              </td>
                              <td v-else>
                                 <!-- You can add any content or leave it empty based on your requirements -->
                              </td>                          
                              <td>
                                 <span v-if="token[0].booking_id">
                                    <b-button variant="primary" v-b-modal.cancel-modal class="btn-sm mt-2 mr-1" @click="startSession(token[0].doctor_id,token[0].booking_id,token[0].room)" v-if="!selectedDoctorIds.includes(token[0].doctor_id)">Start Session</b-button>  {{ }}
                                 </span>

                                    <b-button  @click="showTokens(token[0].doctor_id)" variant="primary" class="btn-sm mt-2 mr-1" v-if ="selectedDoctorIds.includes(token[0].doctor_id) && token[0].start_session_status">No show Tokens</b-button><br>
                                 <!-- <router-link :to="{ name: 'doctors.tokens.manage' }"  class="btn btn-primary me-2 mb-2 btn-sm" v-if ="start">No show Tokens</router-link><br> -->

                                 <!-- <b-button variant="primary" class="btn-sm mt-2 mr-1"  v-if ="start">No show Tokens</b-button> -->
                                 <!-- <b-button v-b-modal.addroom-modal variant="primary" class="float-end">Start Session</b-button> -->

                              </td>
                           </tr>
                           
                        </tbody>
                        <tbody v-else>
                           <tr>
                              <td colspan="6" class="text-center">No Tokens found</td>
                           </tr>
                        </tbody>
                     </table>
                   
                  </div>
                  <!---- listing table ends -------->
            
                  <!----pagination starts --->     
                  <caption v-if="Boolean(token.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in links" :key="page.label">
                        <a href="#" class="page-link" @click.prevent="fetchTokens(page.url + '&limit='+ listing_length)">
                           <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                           <i v-else-if="index == links.length-1" class="mdi mdi-chevron-right"></i>
                           <span v-else>{{page.label}}</span>                          
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->
                  <!---- modal starts ---->
                  <b-modal ref="addroom-modal" id="addroom-modal" :title="modal_title" hide-footer >
                     <b-form>                        
                        <div class="row"> 
                           <b-form-group md="12">
                              <label>Room Number</label>
                              <b-form-input  v-model="doctor.room"></b-form-input>
                           </b-form-group>
                           <b-col md="12" class="mt-3">
                                 <!-- <b-button class="me-3" variant="primary" >{{ button_title }}</b-button> -->
                                 <b-button class="me-3" variant="primary" @click="addRoom()" >Save</b-button>
                           </b-col>
                        </div>                       
                        </b-form>
                     </b-modal>
                  <!---- modal ends ----->
                  <b-modal ref="noshow-modal" id="noshow-modal" :title="modal_title" hide-footer >
                     <b-form>                        
                        <div class="row" v-for="(noShowToken) in noShowTokens" :key="noShowToken.id"> 
                           <div class="col-md-12">
                              <div class="card mini-stats-wid">
                           <!-- <div class="card-body"> -->
                              
                                 <!-- <div class="media-body"> -->
                                 <p class="text-muted fw-medium mb-2 font-size-16">{{noShowToken.name}}                                     
                                    <span class="badge bg-primary rounded-pill">{{noShowToken.token}}</span> | Age: {{calculateAge(noShowToken.dob)}} | 
                                 <span v-if="noShowToken.gender === 1">Male</span>
                                 <span v-if="noShowToken.gender === 2">Female</span>
                                 <span v-if="noShowToken.gender === 3">Others</span>
                                    <b-button variant="primary" @click="tokenRecall(noShowToken.booking_id,1)" class="btn-sm mt-2 mr-1 float-end me-3">Recall</b-button> 
                                 </p> 
                                 
                                       <!-- </div> -->
                                 <!-- </div> -->
                              </div>
                           </div>
                        </div>  
                        <b-col md="12" class="mt-3">
                              <!-- <b-button type="submit" class="me-3" variant="primary" @click="startSession()">{{ button_title }}</b-button> -->
                              <b-button class="me-3" variant="light" @click="hideModal('noshow-modal')" >Close</b-button>
                        </b-col>                     
                     </b-form>
                  </b-modal>
               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
